export const formatDate = (post_date: string) => {
  if (!post_date) return ''

  const intervals = [
    { label: 'year', seconds: 31536000 },
    { label: 'month', seconds: 2592000 },
    { label: 'day', seconds: 86400 },
    { label: 'hour', seconds: 3600 },
    { label: 'min', seconds: 60 },
    { label: 'second', seconds: 0 },
  ]
  const optionsYear = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  } as const
  const optionsMonth = { month: 'short', day: 'numeric' } as const

  const date = new Date(post_date)

  const seconds = Math.floor((Date.now() - date.getTime()) / 1000)
  const interval = intervals.find((i) => i.seconds < seconds) || {
    label: '',
    seconds: 0,
  }
  const count = Math.floor(seconds / interval.seconds)

  if (interval.label === 'year') {
    return date.toLocaleDateString('en-PH', optionsYear)
  }

  if (interval.label === 'month') {
    return date.toLocaleDateString('en-PH', optionsMonth)
  }

  if (interval.label === 'day' && count === 1) {
    return `Yesterday`
  }

  if (interval.label === 'day' || 'hour' || 'min') {
    return `${count} ${interval.label}${count !== 1 ? 's' : ''} ago`
  }
}

export const abbreviateNumber = (value: number): string => {
  let newValue = String(value)
  if (value >= 1000) {
    const suffixes = ['', 'k', 'm', 'b', 't']
    const suffixNum = Math.floor(('' + value).length / 3)
    let shortValue
    for (let precision = 2; precision >= 1; precision--) {
      shortValue = parseFloat(
        (suffixNum != 0
          ? value / Math.pow(1000, suffixNum)
          : value
        ).toPrecision(precision),
      )
      const dotLessShortValue = (shortValue + '').replace(/[^a-zA-Z 0-9]+/g, '')
      if (dotLessShortValue.length <= 2) {
        break
      }
    }
    if (shortValue && shortValue % 1 != 0) shortValue = shortValue.toFixed(1)
    newValue = shortValue + suffixes[suffixNum]
  }
  return newValue
}

export const formatGenderUrl = (gender: string) => {
  if (gender === 'male') return 'm'
  return 'f'
}
export const formatGender = (gender: string) => {
  if (gender === 'm') return 'male'
  return 'female'
}
